import React from 'react';
import {useTranslation} from 'react-i18next';

import {IconHelp} from '@veneer/core';

import {Notifications} from '@br/mg-components';

import {A} from '../../../Links';
import {WFCButton} from '../../../WFCButton';
import LanguageSelector from '../../../src/LanguageSelector/LanguageSelector';

import {ActionsProps} from './types';

const Actions = ({
    setLanguage,
    getLanguages,
    contextHelpUrl,
    showNotificationCenter,
    currentLanguage,
}: ActionsProps) => {
    const {t} = useTranslation(['AppHeader']);
    const supportLabel = t('AppHeader:support', 'Get Support');

    return (
        <>
            <LanguageSelector
                setLanguage={setLanguage}
                currentLanguage={currentLanguage}
                getLanguages={getLanguages}
            />
            {contextHelpUrl && (
                <A
                    href={contextHelpUrl}
                    tabIndex={-1}
                    target="__blank"
                    aria-label={supportLabel}
                >
                    {/* eslint-disable-next-line no-restricted-syntax */}
                    <WFCButton
                        role="presentation"
                        aria-label={supportLabel}
                        leadingIcon={<IconHelp aria-hidden />}
                        small
                    />
                </A>
            )}
            {showNotificationCenter && <Notifications />}
        </>
    );
};

export default Actions;
